import { createStore as reduxCreateStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'

const LOCALSTORAGE_KEY = 'bookingportalstate'
const initialState = {
  endpoint: null,
  timezone: null,
  step: 0,
  day: null,
  time: null,
  page: {},
  answers: {},
  payment: null,
  paymentProvider: null,
  paymentError: null,
  isCustomTime: false,
  requestTimeMessage: "",
  savedAppointment: null,
  coupon: null,
}

export const reducers = (state = initialState, action) => {
  switch (action.type) {
    case 'SET':
      if (action.hasOwnProperty('data')) {
        state = {
          ...state,
          ...action.data,
        }
      } else {
        state = {
          ...state,
          [action.key]: action.value,
        }
      }
      break
    case 'RESET':
      state = {
        ...initialState,
        timezone: state.timezone,
        page: state.page,
        reset: true,
      }
      break
    default:
      break
  }

  window.localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(state))
  return state
}

export const setDay = (day) => {
  return { type: 'SET', key: 'day', value: day }
}

export const setTime = (time) => {
  return { type: 'SET', key: 'time', value: time }
}

export const setTimezone = (timezone) => {
  return { type: 'SET', key: 'timezone', value: timezone }
}

export const setIsCustomTime = (isCustomTime) => {
  return { type: 'SET', key: 'isCustomTime', value: isCustomTime }
}

export const setRequestTimeMessage = (message) => {
  return { type: 'SET', key: 'requestTimeMessage', value: message }
}

export const setReset = (reset) => {
  return { type: 'SET', key: 'reset', value: reset}
}

export const setAnswers = (newAnswers) => {
  return (dispatch, getState) => {
    const state = getState()
    const answers = {
      ...state.answers,
      ...newAnswers,
    }
    dispatch({
      type: 'SET',
      key: 'answers',
      value: answers,
    })
  }
}

export const setStepWithAnswers = (step, newAnswers) => {
  return (dispatch, getState) => {
    const state = getState()
    const answers = {
      ...state.answers,
      ...newAnswers,
    }

    dispatch({
      type: 'SET',
      key: 'answers',
      value: answers,
    })
    dispatch({
      type: 'SET',
      key: 'step',
      value: step,
    })

    if (shouldRemoveCoupon(state, newAnswers)) {
      dispatch({
        type: 'SET',
        key: 'coupon',
        value: null,
      })
    }
  }
}

const shouldRemoveCoupon = (state, newAnswers) => {
  // If duration changed, remove any applied coupons
  if (newAnswers.booking_duration && newAnswers.booking_duration !== state.answers.booking_duration) {
    return true
  }

  // If duration changed, remove any applied coupons
  if (newAnswers.booking_service && newAnswers.booking_service !== state.answers.booking_service) {
    return true
  }

  return false
}

export const setEndpoint = (resourceId, resourceType) => {
  return (dispatch, getState) => {
    const state = getState()
    const endpoint = state.endpoint || {}
    // If endpoint has changed, or never existed
    if (endpoint.resourceId !== resourceId || endpoint.resourceType !== resourceType) {
      // If it did exist, we reset the whole state as values are no longer valid,
      // completely wipe the booking portal state and reload.
      if (endpoint.resourceId) {
        dispatch({ type: 'RESET' })
        return
      }
      dispatch({
        type: 'SET',
        key: 'endpoint',
        value: {
          resourceId,
          resourceType,
        },
      })
    }
  }
}

export const setStep = (step) => {
  return { type: 'SET', key: 'step', value: step }
}

export const setPaymentProvider = (provider) => {
  return { type: 'SET', key: 'paymentProvider', value: provider }
}

export const setPayment = (payment) => {
  return { type: 'SET', key: 'payment', value: payment }
}

export const setPaymentError = (error) => {
  return { type: 'SET', key: 'paymentError', value: error }
}

export const setSavedAppointment = (appointment) => {
  return { type: 'SET', key: 'savedAppointment', value: appointment }
}

export const setCoupon = (coupon) => {
  return { type: 'SET', key: 'coupon', value: coupon }
}

export const createStore = (state = initialState) => {
  // TODO: protect against corruption
  const persistedState = JSON.parse(window.localStorage.getItem(LOCALSTORAGE_KEY) || '{}')
  const initialStoreState = {
    ...state,
    ...persistedState,
  }
  const enhancers = [
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  ].filter(f => f)
  return reduxCreateStore(
    reducers,
    initialStoreState,
    compose(...enhancers),
  )
}
